import {
    deleteTokensOperation,
    setTokenAccessOperation,
    setTokenRefreshOperation,
    setTokenWellFunnelOperation,
} from 'store/auth/operations';
import { getAuthToken, getAuthTokenRefresh, getAuthWellFunnelToken } from 'store/auth/accessors';

export const getToken = () => {
    return getAuthToken();
};

export const getWellFunnelToken = () => {
    return getAuthWellFunnelToken();
};

export const getTokenRefresh = () => {
    return getAuthTokenRefresh();
};

export const removeTokens = (): void => {
    deleteTokensOperation();
};

export const setTokenAccess = (token: string): void => {
    setTokenAccessOperation(token);
};

export const setAccessRefreshTokens = ({ access, refresh }: { access: string; refresh: string }): void => {
    setTokenAccess(access);
    setTokenRefresh(refresh);
};

export const setWellFunnelToken = (token: string): void => {
    setTokenWellFunnelOperation(token);
};

export const setTokenRefresh = (token: string): void => {
    setTokenRefreshOperation(token);
};
